<template>
  <main class="pt-10 container mx-auto max-w-5xl">
    <div class="flex justify-between items-center">
      <img
        :width="200"
        src="@/assets/images/logo.png"
        alt="logo"
      >
      <DropdownMenu>
        <DropdownMenuTrigger
          class="cursor-pointer"
          as-child
        >
          <div class="flex items-center gap-3">
            <CAvatar :user="user" />
            <div class="grid flex-1 text-left text-sm leading-tight">
              <span class="truncate font-medium">
                {{ user?.full_name }}
              </span>
              <span class="truncate text-xs">{{ user?.email }}</span>
            </div>
            <ChevronsUpDown class="ml-auto" />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem>
            <UserProfileCard :user="user" />
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            class="cursor-pointer"
            @click="authStore.Logout"
          >
            Log out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
    <div class="mt-10 mb-20">
      <RouterView />
    </div>
  </main>
</template>
<script setup lang="ts">
import UserProfileCard from "@/components/common/UserProfileCard.vue";
import {useAuthStore} from "@/stores";
import {ChevronsUpDown} from "lucide-vue-next";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import {storeToRefs} from "pinia";
import CAvatar from "@/components/common/CAvatar.vue";
import type { Ref } from "vue";

interface User {
  full_name?: string;
  email?: string;
  role?: string;
  permissions?: any[];
  avatar_url?: string;
  avatar?: string;
  image?: string;
  workspace_id?: string | number;
  [key: string]: any;
}

const authStore = useAuthStore()
const {user} = storeToRefs(authStore) as { user: Ref<User> }


</script>
